import React, { createContext, MutableRefObject, useContext, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuthProfile } from "../../app/hooks" // Assuming this hook provides necessary user info
import { store } from '../../app/store' // /app/store';
import { INITIAL_URL_PARAMS, INITIAL_URL_SEARCH } from '../..';
import { addTrace } from '../../app/debugTrace';
import Skeleton from '@mui/material/Skeleton';
import patientPin from "../../assets/patienticon.svg";
// --- CHATCORE IMPORTS ---
import {
  BasicStorage,
  ChatMessage,
  ChatProvider,
  ConversationId,
  ConversationRole,
  MessageContentType,
  Participant,
  Presence,
  TypingUsersList,
  UpdateState,
  useChat,
  User,
  UserStatus,
  Sender,
  MessageDirection,
  SenderType,
  MessageStatus,
  IStorage,
  Conversation as Convo

} from "@chatscope/use-chat";

import { GetPopulateStateMethod, ChatService, ServiceState, countTotalUnreadMessages } from '../../features/chatService'//'../../features/PollingChatService'; 
// --- UI AND STYLE IMPORTS ---
import { Divider, Container, Box, Stack, Button, Dialog, DialogContent, DialogTitle, IconButton, Link, Paper, LinearProgress, Typography, CircularProgress } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import "./chatscope-overrides.css";
import {
  MessageModel,
  ConversationContentProps,
  MainContainer,
  ChatContainer,
  ConversationHeader,
  Search,
  ConversationList,
  MessageSeparator,
  Conversation,
  Sidebar,
  Avatar,
  MessageList,
  Message,
  MessageInput,
  MessageGroup,
} from '@chatscope/chat-ui-kit-react';

import { nanoid } from '@reduxjs/toolkit';
import { chatscopeApi, useGetChatStateQuery, useGetConversationsQuery, useGetMessagesQuery, useSetReadConversationMutation } from '../../features/useChatSlice';
import { CreateConversationFromRaw, RawConversation, RawConversationOptionalId, RawMessage } from '../../features/chatSelectors';
import { skipToken } from '@reduxjs/toolkit/query';
import { update } from 'lodash';
import { UnAuthorizedMessage } from './UnAuthorizedMessage';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { AIProfile } from "../AI/AIProfile";
import { useAIProfileForPinClicked } from "../AI/AIhook";
import { useLocation, useSearchParams } from 'react-router-dom';
import { NoChatsMessage } from './NoChatsMessage';
import { CircularProgressCentered } from '../../app/components/sharedcomponents';
import { SkeletonWithRetry } from '../../app/components/ProfileFetchError';
import Chip from '@mui/material/Chip';
import './spotlight.css';
import { useInAppMessageAgentMutation } from '../../features/adminSlice';
//import { ChatExample } from './example/example';
//import { ConversationListSideBar } from './example/components/Chat';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import EditNoteIcon from '@mui/icons-material/EditNote';
import GroupsIcon from '@mui/icons-material/Groups';
import LockIcon from '@mui/icons-material/Lock';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { AppLayout, AuthLayout } from '../../App';
import { PatchedChatProvider } from './PatchedChatProvider';
import { PollingChatDataService } from '../../features/pollingChatDataService';
import { ChatMessageContent } from './ChatMessageContent';
import { printError } from '../../app/utils';

const ConversationsLoadingSkeleton: React.FC = () => {
  const isMobile = window.innerWidth < 900;
  return (
    <Paper elevation={0} sx={{
      flex: 1,
      minWidth: 0,
      minHeight: 0,
      m: { xs: 1.5, sm: 3 },
      mt: { xs: 2, sm: 3 },
      borderRadius: { xs: 3, sm: 4 },
      overflow: 'hidden',
      backgroundColor: 'rgba(244, 240, 255, 0.55)',
      backdropFilter: 'blur(24px)',
      WebkitBackdropFilter: 'blur(24px)',
      border: '1px solid rgba(164, 142, 233, 0.18)',
      boxShadow: '0 4px 24px rgba(0, 0, 0, 0.06)',
    }}>
      <MainContainer style={{ width: '100%', height: '100%', maxHeight: '100%', backgroundColor: 'transparent' }}>
        <Sidebar position="left" scrollable style={{ display: 'flex', maxWidth: '100%', flexBasis: isMobile ? '100%' : '25%', flexGrow: 2 }}>
          <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {[...Array(5)].map((_, i) => (
              <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 0.5 }}>
                <Skeleton variant="circular" width={40} height={40} sx={{ flexShrink: 0 }} />
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Skeleton variant="text" width="70%" height={20} />
                  <Skeleton variant="text" width="90%" height={16} />
                </Box>
              </Box>
            ))}
          </Box>
        </Sidebar>
        {!isMobile && <ChatContainer>
          <ConversationHeader>
            <ConversationHeader.Content userName={<Skeleton variant="text" width={120} height={24} />} />
          </ConversationHeader>
          <MessageList>
            <Box sx={{ display: 'flex', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
              <Skeleton variant="text" width="40%" height={20} />
            </Box>
          </MessageList>
          <MessageInput disabled style={{ paddingTop: 10, paddingBottom: 10 }} attachButton={false} placeholder="" />
        </ChatContainer>}
        {!isMobile && <Sidebar position="right" style={{ maxWidth: '100%', flexGrow: 2 }}>
          <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center' }}>
            <Skeleton variant="rounded" width={56} height={56} sx={{ borderRadius: '16px', mt: 1 }} />
            <Skeleton variant="text" width="60%" height={28} />
            <Skeleton variant="text" width="80%" height={16} />
            {[...Array(3)].map((_, i) => (
              <Skeleton key={i} variant="rounded" width="100%" height={60} sx={{ borderRadius: '12px' }} />
            ))}
          </Box>
        </Sidebar>}
      </MainContainer>
    </Paper>
  );
};

export const ServiceStateContext = createContext<ServiceState | undefined>(
  undefined
);
//export   interface ToggleResponsiveChat { 'convoList': true, 'mainChat': true, 'expansionPanel': true }
/**
 * ChatContent is responsible for consuming the state from ChatProvider 
 * via the useChat() hook and rendering the UI.
 */
export const ChatContent: React.FC = () => {
  const { currentMessages, conversations, activeConversation, setActiveConversation, addConversation, sendMessage, getUser, currentMessage, setCurrentMessage, sendTyping, setCurrentUser, currentUser, updateState, service } = useChat();
  const { authStatus, profile: loggedInUserProfile, isLoading: isLoadingLoggedInUserProfile, isSuccess: isSuccessLoggedInUserProfile, isError: isErrorLoggedInUserProfile, error: errorLoggedInUserProfile } = useAuthProfile()
  const profileId = loggedInUserProfile?.id
  const [setReadConversation] = useSetReadConversationMutation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const receiverID = activeConversation && loggedInUserProfile
    ? Number(activeConversation.participants.find((participant) => Number(participant.id) !== loggedInUserProfile.id)?.id)
    : undefined;

  const { aiSummary: AIProfileSummary, authProfile: authProfile, profile: profileToUse, isLoading, isSuccess, isError, error } = useAIProfileForPinClicked(receiverID ? receiverID : skipToken)

  let initialResponsiveState = {}
  if (windowWidth > 600) {
    initialResponsiveState = { 'convoList': true, 'mainChat': true, 'expansionPanel': true }
  } else {
    initialResponsiveState = { 'convoList': true, 'mainChat': false, 'expansionPanel': false }
  }
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  //const { directId, directNamePublic } = location.state || {}; // avoid crash if state is undefined
  const queryParams = new URLSearchParams(location.search);
  // Reverted to plain queryParams reading to surface the root cause.
  // Working workaround (keep for reference):
  //   const conversationIdToOpen = INITIAL_URL_PARAMS.get("conversationId") || queryParams.get("conversationId");
  const conversationIdToOpen = queryParams.get("conversationId");
  const directId = searchParams.get("directId");
  const directNamePublic = searchParams.get("directNamePublic");
  const showMessagesOnMobile = !!conversationIdToOpen || !!directId
  // Pane visibility is derived inline from windowWidth + a single piece of
  // user-interaction state (mobilePane). The previous toggleResponsiveChat
  // object + two useEffects approach had a stale-closure bug: after the
  // deep-link effect stripped ?conversationId from the URL, any iPhone resize
  // event (address-bar slide, soft keyboard, content reflow) re-fired the
  // [windowWidth]-deps effect with a stale showMessagesOnMobile=false and
  // flipped the chat pane back to the convo list.
  const [mobilePane, setMobilePane] = useState<'convoList' | 'mainChat' | 'expansionPanel'>(
    showMessagesOnMobile ? 'mainChat' : 'convoList'
  )
  const isDesktop = windowWidth >= 600

  useEffect(() => {
    const handleResize = () => { setWindowWidth(window.innerWidth) };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [serviceState, setServiceState] = useState<ServiceState>((service as ChatService)?.getServiceState() ??
  {
    isLoading: true,
    isError: false,
    isSuccess: false,
    error: undefined,
    data: undefined,
    isInitialized: false
  });

  const { data: serviceData, isLoading: isLoadingChatStateData, isSuccess: isSuccessChatStateData, isInitialized: isInitializedChatStateData, isError: isErrorChatStateData, error: errorChatStateData } = serviceState

  const conversationIdToOpenWithDefaultdRef = useRef<string | undefined>(undefined);
  const activeConvo = conversations.find(c => c.id === activeConversation?.id);
  const isSpotlight = !!activeConvo?.data?.spotlight;
  ///const [userSelectedConvo, setUserSelectedConvo] = useState(false)
  useEffect(() => {
    if (!isInitializedChatStateData || !conversations.length || conversationIdToOpenWithDefaultdRef.current) {
      return;
    }

    let conversationIdToOpenWithDefault: string | undefined;
    let showMessages = false;

    const convoIdsInList = conversations.map(c => c.id).join(',');
    const requestedConvoFound = conversationIdToOpen
      ? conversations.some(c => c.id === conversationIdToOpen)
      : null;
    addTrace('DeepLink:effect-fire',
      `conversationIdToOpen=${String(conversationIdToOpen)} convoIds=[${convoIdsInList}] requestedFound=${String(requestedConvoFound)} activeConvo=${String(activeConversation?.id)}`
    );

    // 1️⃣ Explicit conversationId from query
    if (conversationIdToOpen) {
      conversationIdToOpenWithDefault = conversationIdToOpen;
      showMessages = true;

      setSearchParams(prev => {
        const next = new URLSearchParams(prev);
        next.delete("conversationId");
        return next;
      }, { replace: true });

      // 2️⃣ Direct message bootstrap
    } else if (directId && directNamePublic) {
      const rawConvoObject: RawConversationOptionalId = {
        chat_name: directNamePublic,
        members: [
          { id: loggedInUserProfile.id, name_public: loggedInUserProfile.name_public },
          { id: directId, name_public: directNamePublic }
        ],
        is_named_chat: false,
      };

      const convo = (service as ChatService).matchOrAddNewTempDirectConversation(rawConvoObject);

      if (convo) {
        conversationIdToOpenWithDefault = convo.id;
        showMessages = true;
      } else {
        conversationIdToOpenWithDefault = conversations[0].id;
      }

      setSearchParams(prev => {
        const next = new URLSearchParams(prev);
        next.delete("directId");
        next.delete("directNamePublic");
        return next;
      }, { replace: true });

      // 3️⃣ Fallback
    } else if (!activeConversation) {
      conversationIdToOpenWithDefault = conversations[0].id;
    }

    if (!conversationIdToOpenWithDefault) {
      return
    };

    // 4️⃣ Lock initialization immediately
    conversationIdToOpenWithDefaultdRef.current = conversationIdToOpenWithDefault;

    // 5️⃣ Ensure private journal exists
    const rawPrivateJournalConvoObject: RawConversationOptionalId = {
      chat_name: "My Private Journal",
      members: [{ id: loggedInUserProfile.id, name_public: loggedInUserProfile.name_public }],
      is_named_chat: true,//false,
      metadata: { spotlight: true },
    };

    (service as ChatService).matchOrAddNewTempDirectConversation(rawPrivateJournalConvoObject);

    // 6️⃣ Apply state
    if (activeConversation?.id !== conversationIdToOpenWithDefault) {
      addTrace('DeepLink:setActive', `target=${conversationIdToOpenWithDefault} prevActive=${String(activeConversation?.id)}`);
      setActiveConversation(conversationIdToOpenWithDefault);
      //setUserSelectedConvo( true)

    }
    // Note: no need to call showMainChat() here — mobilePane is initialized
    // optimistically from showMessagesOnMobile at first render, so the chat
    // pane is already selected when a conversationId is in the URL.

  }, [isInitializedChatStateData, conversations, conversationIdToOpen, searchParams,]);


  useEffect(() => {
    if (activeConversation?.id) {
      resetUnreadCounter()
    }
  }, [activeConversation?.id])

  // Diagnostic probe: log when currentMessages.length changes for a valid
  // active conversation, to compare against when messages actually paint.
  useEffect(() => {
    if (!activeConversation?.id) return;
    console.log(
      '[chat-probe] currentMessages.length =', currentMessages.length,
      'activeConvoId =', activeConversation.id,
      'at', performance.now().toFixed(0), 'ms'
    );
  }, [currentMessages.length, activeConversation?.id])

  // Trace ChatContent values into AuthProfileDialog's debug trace.
  // Fires whenever any of these inputs change so we see the timeline.
  const { isMagicLogin: _trace_isMagicLogin, isLoading: _trace_isLoading, isSuccess: _trace_isSuccess, isProfileSuccess: _trace_isProfileSuccess, isAuthenticated: _trace_isAuthenticated, profile: _trace_profile } = useAuthProfile();
  useEffect(() => {
    addTrace('ChatContent:state',
      `convoIdToOpen=${String(conversationIdToOpen)} activeConvo=${String(activeConversation?.id)} profile.id=${String(_trace_profile?.id)} isAuth=${String(_trace_isAuthenticated)} isLoading=${String(_trace_isLoading)} isSuccess=${String(_trace_isSuccess)} isProfileSuccess=${String(_trace_isProfileSuccess)} isMagicLogin=${String(_trace_isMagicLogin)}`
    );
  }, [conversationIdToOpen, activeConversation?.id, location.search, _trace_isAuthenticated, _trace_isLoading, _trace_isSuccess, _trace_isProfileSuccess, _trace_profile?.id])


  useEffect(() => {
    if (service) {
      (service as ChatService).attachSetServiceStateFunc((serviceState: ServiceState) => {
        // Skip refresh-poll updates so the outer skeleton (gated on
        // !isSuccessChatStateData at line 393) and the inner spinner don't
        // re-appear every 30s. Cold-start fetches have newMessagesOnly=false
        // and pass through, carrying the isLoading: true → false transition.
        if (!serviceState.isError && serviceState.data?.newMessagesOnly) {
          return
        }
        setServiceState(serviceState)
      })
    }
  }, [service])



  useEffect(() => {
    if (serviceState?.isSuccess && !currentUser) {
      const user = getUser(profileId.toString())
      if (user) {
        setCurrentUser(user);
      }
    }
  }, [currentUser, profileId, setCurrentUser, serviceState, serviceState?.isSuccess]);

  // Get current user data
  const [currentUserAvatar, currentUserName, user] = useMemo(() => {
    if (activeConversation) {
      const otherParticipants = activeConversation.participants.length > 0 ? activeConversation.participants.filter(p => p.id !== profileId?.toString()) : []
      const participant = otherParticipants.length > 0 ? otherParticipants[0] : undefined;
      if (participant) {
        const user = getUser(participant.id);
        if (user) {
          return [<Avatar src={user.avatar} />, user.username, user]
        }
      }
    }

    return [undefined, undefined];

  }, [activeConversation]);

  // Renders a loading state if no conversations have been loaded yet


  // --- HELPER FUNCTIONS ---
  const handleSend = (text: string) => {
    // Logger user (sender)

    const message = new ChatMessage<MessageContentType.TextPlain>({
      id: "",
      content: { body: text },
      contentType: MessageContentType.TextPlain, //.TextHtml,
      sender: new Sender({ id: profileId.toString(), type: SenderType.User }),//senderId: currentUserId,
      direction: MessageDirection.Outgoing,
      // Pending = "in flight"; chatService.ts:sendMessage updates to Sent on
      // success. On failure the status is left at Pending so the UI can
      // visually distinguish a failed send from a confirmed one.
      status: MessageStatus.Pending
    });

    sendMessage({
      message,
      conversationId: activeConversation?.id ?? 'XYZ',
      senderId: profileId.toString(),
    });

    resetUnreadCounter();

  };

  function resetUnreadCounter() {
    if (authStatus !== 'authenticated') return; // guests can't mark-read (write 403s); skip the noise + round-trip (mirrors markMessageRead's guest guard)
    if (!activeConversation?.id) return;
    setReadConversation({ conversationId: Number(activeConversation?.id), userId: profileId })
  }

  function showExpansionPanel() { setMobilePane('expansionPanel') }
  function showConvoList()      { setMobilePane('convoList') }
  function showMainChat()       { setMobilePane('mainChat') }


  // if (!serviceState?.isSuccess && !serviceState?.isInitialized) {
  //   return null
  // }

  if (isErrorChatStateData || isLoadingLoggedInUserProfile || !isSuccessChatStateData) {
    return (<ConversationsLoadingSkeleton />)
  }

  return (
    <>
      {/* TEMP DEBUG: visible on-screen values, before Paper so chatscope can't hide it */}
      {/* Disabled — same info now flows into the AuthProfileDialog trace via the useEffect below. */}
      {/*
      <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999, background: '#FFEB3B', color: '#000', p: 1.5, fontSize: '14px', fontWeight: 700, fontFamily: 'monospace', wordBreak: 'break-all', lineHeight: 1.4 }}>
        <div>[ChatContent] convoIdToOpen={String(conversationIdToOpen)}</div>
        <div>activeConvo={String(activeConversation?.id)}</div>
        <div>router.search={String(location.search)}</div>
        <div>INITIAL={String(INITIAL_URL_SEARCH)}</div>
      </Box>
      */}
      <ServiceStateContext.Provider value={serviceState}>
        <Paper elevation={0} sx={{
          flex: 1,
          minWidth: 0,
          minHeight: 0,
          m: { xs: 1.5, sm: 3 },
          mt: { xs: 2, sm: 3 },
          borderRadius: { xs: 3, sm: 4 },
          overflow: 'hidden',
          backgroundColor: 'rgba(244, 240, 255, 0.55)',
          backdropFilter: 'blur(24px)',
          WebkitBackdropFilter: 'blur(24px)',
          border: '1px solid rgba(164, 142, 233, 0.18)',
          boxShadow: '0 4px 24px rgba(0, 0, 0, 0.06)',
        }}>
        <MainContainer
          style={{
            width: '100%',
            height: '100%',
            maxHeight: '100%',
            backgroundColor: 'transparent',
          }}
        >

          <ConversationListSideBar onClick={(id) => {
            setActiveConversation(id);
            showMainChat()
          }
          } style={{
            display: isDesktop || mobilePane === 'convoList' ? 'flex' : 'none',
            // TEMP TEST (kept for reference): display: isDesktop ? 'flex' : 'none',
            maxWidth: '100%',
            flexBasis: '25%',
            flexGrow: 2
          }} />

          <ChatContainer onClick={resetUnreadCounter} style={{ display: isDesktop || mobilePane === 'mainChat' ? 'flex' : 'none' }}>
          {/* TEMP TEST (kept for reference): <ChatContainer onClick={resetUnreadCounter} style={{ display: 'flex' }}> */}
            <ConversationHeader>
              <ConversationHeader.Back onClick={showConvoList} style={{ display: windowWidth >= 600 ? 'none' : 'flex' }} />
              <ConversationHeader.Content userName={
                activeConvo?.data?.spotlight
                  ? activeConvo?.description
                  : currentUserName
              }
              />
              <ConversationHeader.Actions>
                <IconButton onClick={showExpansionPanel} size="small" sx={{ display: windowWidth >= 600 ? 'none' : 'flex', color: '#656EFF' }}>
                  <InfoIcon fontSize="small" />
                </IconButton>
              </ConversationHeader.Actions>
            </ConversationHeader>
            {(isLoadingChatStateData || !activeConversation?.id) && conversations.length > 0 &&
              <Stack sx={{ position: 'relative', display: 'flex', flex: 1, height: '100%', justifyContent: 'center', alignItems: 'center', gap: 2 }}>
                <CircularProgressCentered />
                <Typography>Loading messages…</Typography>
              </Stack>
            }
            {activeConversation && <MessageList>
              {currentMessages.map(
                (g, gIndex, arr) => {
                  return (
                    <MessageGroup key={g.id} direction={g.direction}>
                      <MessageGroup.Messages key={gIndex}>
                        {g.messages.map((m: ChatMessage<MessageContentType>, index) => {
                          // Compare against the immediate temporal predecessor:
                          // within-group when index>0, else the prior group's tail.
                          // Chatscope groups by sender only, so a same-sender run can
                          // cross a day boundary — the within-group check is what
                          // surfaces those separators.
                          const prevMessage = index > 0
                            ? g.messages[index - 1]
                            : arr[gIndex - 1]?.messages[arr[gIndex - 1].messages.length - 1];
                          const prevDate = prevMessage?.createdTime;
                          const currDate = m.createdTime;
                          const showSeparator = !prevDate ||
                            prevDate.toLocaleDateString() !== currDate.toLocaleDateString();

                          return (
                            <React.Fragment key={index}>
                              {showSeparator && (
                                <MessageSeparator content={currDate.toLocaleDateString(undefined, { dateStyle: 'medium' })} />
                              )}
                              <Message key={m.id} model={{
                                type: "text",
                                payload: m.content.body,
                                direction: m.direction,
                                position: "normal"
                              }}>
                                {index === 0 && <Message.Header>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      fontSize: "0.7rem",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    <Typography component="span" variant="caption" sx={{ fontWeight: 600 }}>
                                      {(m?.data as any)?.activity && <Typography component="span" variant="caption" sx={{ fontWeight: 600, }}>
                                        {(m?.data as any)?.activity}
                                      </Typography>}
                                      {`${((m?.data as any)?.activity && activeConversation?.participants.length > 2 && m.direction === MessageDirection.Incoming) ? ' by ' : ''}`}
                                      {(activeConversation?.participants.length > 2 && m.direction === MessageDirection.Incoming) && <Typography component="span" variant="caption" sx={{ fontWeight: 600, }}                                    >
                                        {m.sender?.id ? getUser(m.sender.id)?.username ?? "Guest" : "Guest"}
                                      </Typography>}
                                    </Typography>
                                  </Box>
                                </Message.Header>}
                                {/* Outgoing-message status footer:
                                    status===Pending && !data.failed → gray "Sending" (in flight)
                                    status===Pending &&  data.failed → red  "Not sent" (hard failure, set in chatService catch)
                                    status===Sent                    → no footer (success) */}
                                {m.direction === MessageDirection.Outgoing && m.status === MessageStatus.Pending && (
                                  <Message.Footer>
                                    {(m?.data as any)?.failed ? (
                                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: '#d32f2f', fontSize: '11px' }}>
                                        <ErrorOutlineIcon sx={{ fontSize: '14px' }} />
                                        <span>Not sent</span>
                                      </Box>
                                    ) : (
                                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: '#757575', fontSize: '11px' }}>
                                        <ScheduleSendIcon sx={{ fontSize: '14px' }} />
                                        <span>Sending</span>
                                      </Box>
                                    )}
                                  </Message.Footer>
                                )}
                              </Message>
                            </React.Fragment>
                          )
                        })}
                      </MessageGroup.Messages>
                    </MessageGroup>
                  )
                }
              )}
              {currentMessages.length == 0 &&
                <Stack sx={{ display: 'flex', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                  <Typography>
                    Send a message to start a conversation
                  </Typography>
                </Stack>
              }
            </MessageList>}
            <MessageInput style={{ paddingTop: 10, paddingBottom: 10 }} attachButton={false} placeholder="Type message here" onSend={handleSend} />
          </ChatContainer>
          <Sidebar
            position="right"
            style={{
              display: isDesktop || mobilePane === 'expansionPanel' ? 'flex' : 'none',
              maxWidth: '100%',
              flexGrow: 2,
            }}
          >
            <Box sx={{ p: 2, overflow: 'auto', height: '100%' }}>
              <Box sx={{ display: windowWidth >= 600 ? 'none' : 'flex', mb: 1.5 }}>
                <Button
                  onClick={showMainChat}
                  size="small"
                  startIcon={<ArrowBackIcon sx={{ fontSize: '16px !important' }} />}
                  sx={{
                    textTransform: 'none',
                    fontSize: '13px',
                    fontWeight: 600,
                    color: '#656EFF',
                    backgroundColor: 'rgba(101, 110, 255, 0.08)',
                    borderRadius: '20px',
                    px: 1.5,
                    py: 0.5,
                    minWidth: 0,
                    lineHeight: 1.4,
                    transition: 'all 0.15s ease',
                    '&:hover': { backgroundColor: 'rgba(101, 110, 255, 0.15)' },
                  }}
                >
                  Back
                </Button>
              </Box>
              {((activeConversation?.description.includes('Community Journal') || activeConversation?.description.includes('Private Journal')))
                &&
                <Stack gap={2.5} sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box sx={{
                    width: 56, height: 56, borderRadius: '16px',
                    background: 'linear-gradient(135deg, #EEEDFF 0%, #D4D2FF 100%)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    mt: 1,
                  }}>
                    <MenuBookIcon sx={{ fontSize: 28, color: '#656EFF' }} />
                  </Box>
                  <Typography variant="h6" sx={{ fontWeight: 700, color: '#1a1a2e', textAlign: 'center', lineHeight: 1.3 }}>
                    Your Journal
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#888', textAlign: 'center', lineHeight: 1.5 }}>
                    A space to reflect, share, and grow with your community.
                  </Typography>

                  <Stack gap={1.5} sx={{ width: '100%', mt: 0.5 }}>
                    {[
                      { icon: <EditNoteIcon sx={{ fontSize: 20, color: '#656EFF' }} />, title: 'Reflect & Track', desc: 'Record your journey and revisit your progress over time.' },
                      { icon: <GroupsIcon sx={{ fontSize: 20, color: '#656EFF' }} />, title: 'Community Insights', desc: 'Your entries help others learn and feel supported.' },
                      { icon: <LockIcon sx={{ fontSize: 20, color: '#656EFF' }} />, title: 'Your Choice', desc: 'Write privately or share publicly — you\'re always in control.' },
                    ].map((item, i) => (
                      <Box key={i} sx={{
                        display: 'flex', gap: 1.5, alignItems: 'flex-start',
                        p: 1.5, borderRadius: '12px',
                        backgroundColor: '#F7F6FF',
                        border: '1px solid #EEEDFF',
                        transition: 'all 0.15s ease',
                        '&:hover': { backgroundColor: '#EEEDFF', borderColor: '#D4D2FF' },
                      }}>
                        <Box sx={{
                          minWidth: 36, height: 36, borderRadius: '10px',
                          backgroundColor: '#EEEDFF',
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}>
                          {item.icon}
                        </Box>
                        <Box>
                          <Typography variant="body2" sx={{ fontWeight: 600, color: '#1a1a2e', mb: 0.25 }}>{item.title}</Typography>
                          <Typography variant="caption" sx={{ color: '#777', lineHeight: 1.4 }}>{item.desc}</Typography>
                        </Box>
                      </Box>
                    ))}
                  </Stack>
                </Stack>
              }
              {(!isSpotlight && AIProfileSummary) &&
                <AIProfile bottomSheetRef={null} profileToShow={profileToUse} AIProfileSummary={AIProfileSummary} showMessageButton={false} showViewUserStoryAnalytics={false} chatMode={true} />
              }
            </Box>
          </Sidebar>
        </MainContainer>
        </Paper>
      </ServiceStateContext.Provider>
    </>
  )
}

const globalAny = window as any;

export const pollingChatDataService: PollingChatDataService = globalAny.__pollingChatDataService ||
  (globalAny.__pollingChatDataService = new PollingChatDataService(store.dispatch, () => store.getState()))

export const messageIdGenerator = (message: ChatMessage<MessageContentType>) => nanoid();
export const groupIdGenerator = () => nanoid();

//Global storage and subscriptions for Home and Conversations screens
export const chatStorageHomePage =
  globalAny.__chatStorage1 ||
  (globalAny.__chatStorage1 = new BasicStorage({ groupIdGenerator, messageIdGenerator }))
export const commmunityJournalConversationFilter = (convoId: number) => convoId === 1
const homePagePopulateStateMethod = GetPopulateStateMethod(chatStorageHomePage, undefined, commmunityJournalConversationFilter)
pollingChatDataService.subscribe(chatStorageHomePage, homePagePopulateStateMethod)//, homePagePopulateStateMethod)

export const chatStorageConversations =
  globalAny.__chatStorage ||
  (globalAny.__chatStorage = new BasicStorage({ groupIdGenerator, messageIdGenerator }));
//const populateStateMethod = GetPopulateStateMethod(chatStorageConversations)
pollingChatDataService.subscribe(chatStorageConversations)//, populateStateMethod)

export const getUnreadMessagesAllConverstations: () =>number | undefined = () => countTotalUnreadMessages(chatStorageConversations)

export const PATIENT_CONNECT_AI_PROFILE_ID = 2
// Anonymous profile that the backend resolves to when no real session
// exists. Used so unauthenticated visitors can still see the community
// Journal channel on the home page. Polling for this profile is
// intentionally suppressed when a magic-link token (?t=) is pending
// verification — see chatService.ts.
export const UNAUTHENTICATED_PROFILE_ID = 361
/**
 * ChatScope handles service initialization and wraps ChatContent in the ChatProvider.
 */
export const ChatScopeUseChatConversations: React.FC = () => {
  const { authStatus, profile: loggedInUserProfile, isLoading: isLoadingLoggedInUserProfile, isSuccess: isSuccessLoggedInUserProfile, isError: isErrorLoggedInUserProfile, error: errorLoggedInUserProfile } = useAuthProfile()
  const [inAppMessageAgent, { isLoading: isUpdatingMessageAgent, isSuccess: isSuccessMessageAgent, isError: isErrorMessageAgent, error: errorMessageAgent, data: messageAgentData/*, reset*/, originalArgs: originalArgsMessageAgent }] = useInAppMessageAgentMutation()

  if (isLoadingLoggedInUserProfile) {//||  !loggedInUserProfile){
    return (<AppLayout><ConversationsLoadingSkeleton /></AppLayout>)
  }

  if (/*isSuccessLoggedInUserProfile &&*/ authStatus === 'unauthenticated') {
    return (<AuthLayout>
      <UnAuthorizedMessage />
    </AuthLayout>)
  }
  if (isErrorLoggedInUserProfile) {//||  !loggedInUserProfile){
    console.error("LoggedInUserProfile Error", printError(errorLoggedInUserProfile))
    return (<AppLayout><ConversationsLoadingSkeleton /></AppLayout>)
  }

  return (
    <AppLayout>
      <ChatScopeUseChatMinimal loggedInUserProfile={loggedInUserProfile} storage={chatStorageConversations} onSend={async (message: RawMessage, convo: Convo, loggedInUserProfile: any) => {
        if (convo.participants.length !== 2) return
        let hasAI = false;
        let hasLoggedInUser = false;
        for (const p of convo.participants) {
          if (p.id === `${PATIENT_CONNECT_AI_PROFILE_ID}`) hasAI = true;
          if (p.id === `${loggedInUserProfile?.id}` /*userId.toString()*/) hasLoggedInUser = true;
          if (hasAI && hasLoggedInUser) break;
        }
        if (hasAI && hasLoggedInUser) {//conversation with AI{
          inAppMessageAgent({ message, profile: loggedInUserProfile });
        }
      }} >
        <ChatContent />
      </ChatScopeUseChatMinimal>
    </AppLayout>
  );

}
export type ChatScopeHandle = {
  getChatService: () => ChatService | null
}
//export const ChatScopeUseChatMinimal: React.FC<{ storage: IStorage<any, any>, chatService: ChatService, onSend?: (message: RawMessage, convo: Convo, loggedInUserProfile: any) => void}> = ({onSend, storage}) => {
export const ChatScopeUseChatMinimal =
  React.forwardRef<ChatScopeHandle, {
    storage: IStorage<any, any>,
    loggedInUserProfile: any,
    onSend?: (message: RawMessage, convo: Convo, loggedInUserProfile: any) => void,
    children?: React.ReactNode,
    conversationFilter?:  (convoId: number) => boolean
  }>(({ onSend, storage, loggedInUserProfile, children/*= <ChatMessageContent />*/, conversationFilter }, ref) => {
    const [serviceState, setServiceState] = useState<ServiceState>({
      isLoading: true,
      isError: false,
      isSuccess: false,
      error: undefined,
      data: undefined,
      isInitialized: false

    });
    const { data: chatStateData, isLoading: isLoadingChatStateData, isSuccess: isSuccessLoggedChatStateData, isError: isErrorChatStateData, error: errorChatStateData } = serviceState

    const dispatch = useDispatch()
    const chatServiceRef = React.useRef<ChatService | null>(null)

    // Magic-link gate: when the session started with ?t= and auth hasn't
    // fully resolved yet, defer ChatService construction. Otherwise the
    // constructor fires with the guest profile id (361) and the polling
    // service issues a cold fetch for the wrong user — see
    // MAGIC_LINK_ARCHITECTURE.md.
    //
    // None of the combined flags from useAuthProfile() catches the success
    // mid-update window — confirmed empirically with debug trace. Right after
    // customAuth.login, every flag (isLoading, isSuccess, isProfileSuccess,
    // isAuthenticated) reads as "done", yet loggedInUserProfile.id is still
    // 361. The reason: customAuth.login dispatches setSessionForRTK
    // synchronously, but AuthBootstrap.ts's getUserProfileArg only flips
    // from guest args to real-user args once authUser/sub/email/phone are
    // all populated — which lands a tick or two later than the slice update.
    // So isProfileSuccess reflects the prior successful guest fetch.
    //
    // The only signal that reliably catches the transition is the profile id
    // itself: if isAuthenticated && loggedInUserProfile.id === guest id, we
    // know the profile cache is stale.
    //
    // On magic-link FAILURE: customAuth.isAuthenticated stays false →
    // isMidUpdate=false → gate driven by isLoading, which resolves via
    // clearSessionRTK at AuthBootstrap.ts:293. ChatService gets constructed
    // with guest 361 → community Journal still loads (graceful degradation).
    const { isMagicLogin, isLoading: isAuthLoading, isAuthenticated } = useAuthProfile();
    const isMidUpdate = isAuthenticated && loggedInUserProfile?.id === UNAUTHENTICATED_PROFILE_ID;
    const isAuthResolving = isMagicLogin && (isAuthLoading || isMidUpdate);

    const serviceFactory = useMemo(() =>
      (storage: IStorage, updateState: () => void) => {
        return new ChatService(storage, updateState, dispatch, () => store.getState(), loggedInUserProfile?.id, pollingChatDataService, (message: RawMessage, convo: Convo, userId: number) => onSend?.(message, convo, loggedInUserProfile), conversationFilter);// Number(conversationId));
        // if (!chatServiceRef.current) {
        //   chatServiceRef.current = new ChatService(storage, updateState, dispatch, () => store.getState(), loggedInUserProfile?.id, pollingChatDataService, (message: RawMessage, convo: Convo, userId: number) => onSend?.(message, convo, loggedInUserProfile));// Number(conversationId));
        // } else if (chatServiceRef.current.getUserId() !== loggedInUserProfile.id) {
        //   chatServiceRef.current.resetForUser(loggedInUserProfile.id);
        // }
        // //serviceRef.current = chatService;
        // return chatServiceRef.current;
      }, [ loggedInUserProfile?.id])// [loggedInUserProfile?.id,]);//dispatch//setServiceState ]);//conversationId]);

    //TODO - FIX THIS!!!!!!!!!!!
    if (isErrorChatStateData) {//||  !loggedInUserProfile){
      return (<AuthLayout><ConversationsLoadingSkeleton /></AuthLayout>)
    }

    // Block ChatProvider mount until magic-link auth resolves so ChatService
    // isn't constructed with the guest profile id (361) mid-auth.
    if (isAuthResolving) {
      return (<ConversationsLoadingSkeleton />)
    }

    return (

      <PatchedChatProvider serviceFactory={serviceFactory} storage={storage}>
        {/* <ChatContent profileId={loggedInUserProfile?.id} /> */}
        {/* <ChatMessageContent /> */}
        {children}
      </PatchedChatProvider>

    );

  })


export const ConversationListSideBar: React.FC<{ style?: any, onClick?: (id: string) => void }> = ({ style, onClick }) => {
  const { currentMessages, conversations, activeConversation, setActiveConversation, sendMessage, getUser, currentMessage, setCurrentMessage, service, sendTyping, setCurrentUser } = useChat();
  const serviceStatectx = useContext(ServiceStateContext);
  const [userSelectedConvo, setUserSelectedConvo] = useState(false)
  const [lastActiveConvo, setLastActiveConvo] = useState(activeConversation)
  const [setReadConversation] = useSetReadConversationMutation();

  useLayoutEffect(() => {
    setLastActiveConvo(activeConversation)
    if (!activeConversation || userSelectedConvo || activeConversation?.id === lastActiveConvo?.id) return;
    // Scroll the sidebar to the top instead of scrolling to the active conversation
    const sidebar = document.querySelector(".cs-sidebar--left .cs-sidebar__content");
    if (sidebar) {
      sidebar.scrollTop = 0;
    }
  }, [activeConversation, userSelectedConvo, lastActiveConvo?.id]);
  const [spotlightConversations, regularConversations] = conversations.reduce(
    ([spotlight, regular]: [Convo[], Convo[]], convo) => {
      convo.data?.spotlight ? spotlight.push(convo) : regular.push(convo);
      return [spotlight, regular];
    },
    [[], []]
  );

  var nonSpotlightIndex = -1
  return (
    <Sidebar position="left" scrollable style={style ?? {}}>
      <Typography variant="caption" sx={{ px: 2, pt: 1.5, pb: 0.5, display: 'block', color: '#888', fontWeight: 600, letterSpacing: '0.5px', textTransform: 'uppercase', fontSize: '10px' }}>
        Journals
      </Typography>
      {spotlightConversations.map((c, index) => {
        const info = serviceStatectx?.isInitialized ? ((service as ChatService).getLastMessageForConversation(c.id))?.content.body : undefined
        nonSpotlightIndex = (!c.data?.spotlight && nonSpotlightIndex === -1) ? index : nonSpotlightIndex
        return (
          <Conversation style={{ borderBottomWidth: 1, borderBottomStyle: 'solid', borderBottomColor: '#D3D3D3' }} key={c.id} className={c.data?.spotlight ? "spotlight" : ""}
            name={
              c.data?.spotlight ? (
                <>
                  <Chip size="small" label={c.description} sx={{ color: '#6b21a8', background: '#e9d5ff' }} />
                </>
              ) : (
                c.description
              )
            }
            info={info || 'Send your first message'}
            active={activeConversation?.id === c.id}
            unreadCnt={c.unreadCounter}
            onClick={onClick ? () => {
              setUserSelectedConvo(true)
              onClick(c.id)
            } : () => {
              setUserSelectedConvo(true)
              setActiveConversation(c.id)
            }}>

          </Conversation>
        )
      })}
      <Typography variant="caption" sx={{ px: 2, pt: 1.5, pb: 0.5, display: 'block', color: '#888', fontWeight: 600, letterSpacing: '0.5px', textTransform: 'uppercase', fontSize: '10px' }}>
        Your Conversations
      </Typography>
      <ConversationList>
        {regularConversations.map((c, index) => {
          //const isFirstNonSpotlight = index === firstNonSpotlightIndex && firstNonSpotlightIndex !== -1
          const info = serviceStatectx?.isInitialized ? ((service as ChatService).getLastMessageForConversation(c.id))?.content.body : undefined
          nonSpotlightIndex = (!c.data?.spotlight && nonSpotlightIndex === -1) ? index : nonSpotlightIndex
          return (
            <Conversation style={{ borderBottomWidth: 1, borderBottomStyle: 'solid', borderBottomColor: '#D3D3D3' }} key={c.id} className={c.data?.spotlight ? "spotlight" : ""}
              name={
                c.data?.spotlight ? (
                  <>
                    <Chip size="small" label={c.description} sx={{ color: '#6b21a8', background: '#e9d5ff' }} />
                  </>
                ) : (
                  c.description
                )
              }
              info={info || 'Send your first message'}
              active={activeConversation?.id === c.id}
              unreadCnt={c.unreadCounter}
              onClick={onClick ? () => {
                setUserSelectedConvo(true)
                onClick(c.id)
              } : () => {
                setUserSelectedConvo(true)
                setActiveConversation(c.id)
              }}>

            </Conversation>
          )
        })}
      </ConversationList>
    </Sidebar>
  )
}